import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import styled, { withTheme } from 'styled-components'
import ScrollToTopOnMount from '../../components/ScrollToTopOnMount/ScrollToTopOnMount'
import Anime from '../../components/Anime/Anime'
import Button from '../../components/Button/Button'
import Background from '../../components/Background/Background'
import Markdown from '../../components/Markdown/Markdown'
import Image from '../../components/Image/Image'
import Logo from '../../components/Logo/Logo'
import ListItem from '../../components/ListItem/ListItem'
import text from './text.js'
import stars from './stars.svg'
import ferringLogo from './ferring-logo.svg'

const LightBackgroundSection = styled.section`
  background-color: ${props => props.theme.primaryColorWashed};
`

class Home extends Component {
  render () {
    return (
      <Background color={this.props.theme.primaryColor} image={stars}>
        <ScrollToTopOnMount />
        <section className="mw7 center pt2 pt4-ns flex flex-column items-center justify-center ph3 ph4-ns">
          <Logo />
          <Anime translateY={['10px', 0]} opacity={[0, 1]} duration={800} delay={3000}>
            <div className="flex flex-column items-center">
              <Markdown source={text} />
              <Button pill>
                <Link className="db tc w-100 no-underline" to="/steg/barnets-kjonn">
                  Ta testen!
                </Link>
              </Button>
            </div>
          </Anime>
        </section>
        <Image image="images/580x400_gutt.gif" description={'Gutt som sover'} />
        <LightBackgroundSection>
          <ListItem
            title="Ofte stilte spørsmål"
            description="Les svar på de mest vanlige spørsmålene."
            url="/faq"
          />
          <ListItem
            title="Finn din fastlege"
            description="Finn og kontakt din fastlege via helsenorge.no"
            url="https://helsenorge.no/kontakt-fastlegen/kom-i-kontakt"
            rel="noopener"
            target="_blank"
          />
          <ListItem
            title="Lurer du på noe mer?"
            description="Les nyttig artikler og se vidoer på tørrhelenatten.no"
            rel="noopener"
            url="http://www.torrhelenatten.no/"
            target="_blank"
          />
          <section className="pv4 flex flex-column items-center">
            <img src={ferringLogo} alt="" />
          </section>
        </LightBackgroundSection>
      </Background>
    )
  }
}

export default withTheme(Home)



// WEBPACK FOOTER //
// ./src/containers/Home/Home.js